import React, { Fragment } from 'react';
import { nlBr } from '@sizeid/commons/utils/strings';
import Text from '@sizeid/commons/components/Text';

import { CONTACT_PHONE, CONTACT_EMAILS } from 'constants/contact';
import PageSpacer from 'components/Page/PageSpacer';
import Wrapper from 'components/Page/Wrapper';
import H3 from 'components/typo/Heading/H3';
import H4 from 'components/typo/Heading/H4';
import P from 'components/typo/P';
import ContentWhiteBox from 'components/ContentWhiteBox';
import ProtectedEmail from 'components/ProtectedEmail';
import ContactFormPrefab from 'containers/ContactForm';
import { withTranslation } from 'lib/i18n';

import hotline from './images/hotline.svg';
import HotlineImage from './HotlineImage';
import ContactThirds from './ContactThirds';
import { ContactFormProps } from './types';

const ContactForm: React.FC<ContactFormProps> = props => (
  <Wrapper>
    <PageSpacer>
      <ContentWhiteBox>
        <H3>{props.t('contact.form.title')}</H3>
        <P>{props.t('contact.form.text')}</P>
        <ContactFormPrefab organizationsDemo={props.organizationsDemo} />
      </ContentWhiteBox>
      <ContactThirds>
        <ContentWhiteBox>
          <H3>{props.t('contact.hotline')}</H3>
          <HotlineImage src={hotline} />
          <Text semibold size={8}>
            <a href={`tel:${CONTACT_PHONE.replace(/\s/g, '')}`}>
              {CONTACT_PHONE}
            </a>
          </Text>
        </ContentWhiteBox>
        <ContentWhiteBox>
          {['info', 'tech', 'marketing'].map(key => (
            <Fragment key={key}>
              <H4 css="margin-bottom: 4px;">
                {props.t(`contact.emails.${key}`)}
              </H4>
              <Text semibold>
                <ProtectedEmail
                  email={CONTACT_EMAILS[key as keyof typeof CONTACT_EMAILS]}
                  blank
                />
              </Text>
            </Fragment>
          ))}
        </ContentWhiteBox>
        <ContentWhiteBox>
          <H4>{props.t('contact.address.name')}</H4>
          <P size={2}>{nlBr(props.t('contact.address.full'))}</P>
        </ContentWhiteBox>
      </ContactThirds>
    </PageSpacer>
  </Wrapper>
);

export default withTranslation('pages')(ContactForm);
